<template>
    <ul class="pagination product-pagination" v-if="this.pageCount > 1 && !this.$root.emptyFilters">
        <li v-show="currentPage != 1" class="prev">
            <a href="" @click.prevent="prevPage()"><i class="fas fa-chevron-left"></i></a>
        </li>
        <li v-for="page in Array(this.pageCount).fill(1).map((x,y) => x + y)">
            <a :class="page == currentPage ? 'active' : ''" href="#" @click.prevent="changePage(page)">{{ page }}</a>
        </li>
        <li v-show="( pageCount > 1 && currentPage != pageCount )" class="next">
            <a href="" @click.prevent="nextPage()"><i class="fas fa-chevron-right"></i></a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "ProductListingPagination",
        props: {
            productscount: Number
        },
        data: function() {
            return {
                currentPage: 1,
                pageCount: 1,
                perPage: 12,
                products: 1
            }
        },
        mounted() {
            this.products = this.productscount;
            this.$root.$on('updateProductCount', value => {
                this.products = value;
                this.pageCount = Math.ceil(this.products/this.perPage);
            });
            this.$root.$on('productsChangePerPage', per_page => {
                this.perPage = per_page;
                this.pageCount = Math.ceil(this.products/this.perPage);
            });
            this.$root.$on('productsChangePage', page => {
                this.currentPage = page[0];
                if(!page[1]) {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                }
            });
            this.pageCount = Math.ceil(this.productscount/this.perPage);

            // If there is a category parameter present in the url run the filters
            if(this.$root.productCat.length > 0)
                this.$root.$emit('productFilter', {
                    Category : [ this.$root.productCat.replace('-', ' ').replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();}) ]
                });

            // Handle product attributes urls
            var attributes = {}
            for ( var attribute in this.$root.productAttributes ) {
                if ( this.$root.productAttributes[attribute].length > 0 )
                    attributes[attribute.replace('pa_', '')] = [ this.$root.productAttributes[attribute]
                                                    .replace('-', ' ')
                                                    .replace(/\w\S*/g, function(txt) {
                                                        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                                                    }) ]
            }

            if ( Object.keys(attributes).length > 0 )
                this.$root.$emit('productFilter', attributes);
        },
        methods: {
            changePage: function(page) {
                this.$root.$emit('productsChangePage', [page, false]);
                this.currentPage = page;
            },
            nextPage() {
                this.$root.$emit('productsChangePage', [this.currentPage+1, false])
                this.currentPage += 1
            },
            prevPage() {
                this.$root.$emit('productsChangePage', [this.currentPage-1, false])
                this.currentPage -= 1
            }
        }
    }
</script>
